import clsx from 'clsx';

export function Card({ className, children, padded = true, ...rest }) {
  return (
    <div
      className={clsx(
        'rounded-xl border border-border bg-surface-elevated',
        padded && 'p-6',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
